import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportCustomersComponent } from './customers.component';

const routes: Routes = [{ path: '', component: ReportCustomersComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule {}
